import { computed, inject, Injectable, signal } from "@angular/core";
import { ProductionLine } from "../shared/interfaces/productionLine";
import { Workstation } from "../shared/interfaces/workstation";
import { UserService } from "./user.service";
import { Observable } from "rxjs";
import { ApiService } from "./api.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

interface NodeDataState {
  productionLines: ProductionLine[];
  workstations: Workstation[];
}

@Injectable({
  providedIn: "root",
})
export class NodeDataService {
  userService = inject(UserService);
  apiService = inject(ApiService);

  userrole$ = this.userService.userrole();
  productionLines$: Observable<ProductionLine[]> =
    this.apiService.getProductionLinesAdmin();
  workstations$: Observable<Workstation[]> =
    this.apiService.getWorkstationsAdmin();

  private state = signal<NodeDataState>({
    productionLines: [],
    workstations: [],
  });

  productionLines = computed(() => this.state().productionLines);
  workstations = computed(() => this.state().workstations);

  constructor() {
    this.productionLines$
      .pipe(takeUntilDestroyed())
      .subscribe((productionLines: ProductionLine[]) =>
        this.state.update((state) => ({
          ...state,
          productionLines,
        }))
      );

    this.workstations$
      .pipe(takeUntilDestroyed())
      .subscribe((workstations: Workstation[]) =>
        this.state.update((state) => ({
          ...state,
          workstations,
        }))
      );
  }
}
